export const LogoutIcon = () => <i className="fa-regular fa-arrow-right-from-bracket" />
